// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"f23ab11f","442":"28cc9ed8","535":"b8d7b3e8","684":"fdcbd2b6"}[chunkId] + ".chunk.js";
};